import LocaleStoreModel from 'store/models/LocaleStoreModel';

class LocaleStore extends LocaleStoreModel{
}

export default LocaleStore;
